<template>
  <div class="vin">
    <my-head :title="title"/>
    <mu-text-field v-model="form.vin" @blur="" placeholder="VIN" ref="vin" class='input auto-width' @keyup.enter.native="getData()"><i class="iconfont icon-saomiao" @click="scan('vin')"></i></mu-text-field>
    
    <mu-paper class="paper" :z-depth="2" >
      <div class="list-content">库位：<span class="library-position">{{location}}</span></div>
      <mu-button color="info" @click="printValVin">打印</mu-button>
    </mu-paper>
    <scanning v-if="isScanning" :mark="scanMark" v-on:childByValue="childByValue" v-on:closeing="closeing"/>

  </div>
</template>

<script>
import myHead from '@/components/header'
import api from "@/common/api"
import scanning from "@/components/scanning"
export default {
  name: 'vin',
  components: {
    myHead, scanning
  },
  data () {
    return {
      title: "查询VIN码",
      scanMark: "",
      type: '',
      tableLoading: false,
      isScanning: false,
      openFullscreen: false,
      deleteIndex: null, // 删除第几张
      openAlertDj: false,
      openAlert: false, // 删除图片层
      src: [], // 拍照的图片
      files: [], // 图片文件 base64
      bigImg: null,
      location: "", // 库位
      otherTaskTo: false,
      requestOnce: true,
      isSubmited: false,
      Loop: null,
      form: {
        vin: "",
        ASNid:"",
        id: "",
        mile:"",
        ASNcode: "",
        lowEectricity: "0",
        highEectricity: "0",
        isLowEectricity: false,
        isHighEectricity: false,
        isAttachmentFinish: false,
        qcRemark: ""
      },
      sort: {
        name: '',
        order: 'asc'
      },
      columns: [
        { title: '点检项', width: 125, name: 'itemName' },
        { title: '单位', name: 'unit', width: 70, align: 'left'},
        { title: '数量', name: 'quantity', width: 70, align: 'left'},
        { title: '点检数量', name: 'qty', width: "auto", align: 'left'}
      ],
      list: []
    }
  },
  methods: {
    printValVin(){
      this.common.printValVin({
        vin: this.form.vin,
        code: this.location.replace(/-/g,'.'),
        number: 1
      }, ()=>{
      });
    },
    getData(){
      this.Toast.loading({message: '查询中'});
      let data = Object.assign({},this.$store.state.user,{
        content: {
          vin: this.form.vin
        }
      });
      this.tableLoading = true;
      /* 发送post请求 */
      if(this.requestOnce){
        this.common.reqData(api.app('searchVin'), data, res=>{
          this.requestOnce = true;
          this.Toast.clear();
          this.tableLoading = false;
          console.log("返回数据：", res.data)
          if(res.data.status == 100){
            this.location = res.data.content.data.code || "";
            //             this.list = res.data.content.Details || [];
            // this.form.ASNid = res.data.content.ASNid;
            // this.form.id = res.data.content.id;
            // this.form.mile = res.data.content.mile;
            // this.form.lowEectricity = res.data.content.lowEectricity;
            // this.form.highEectricity = res.data.content.highEectricity;
            // this.form.isHighEectricity = res.data.content.isHighEectricity;
            // this.form.isAttachmentFinish = res.data.content.isAttachmentFinish;
            // this.form.qcRemark = res.data.content.qcRemark;
            // this.form.ASNcode = res.data.content.ASNcode;
            // this.form.isLowEectricity = res.data.content.isLowEectricity;
            // this.form.type = res.data.content.type || '';
            // this.isSubmited = false;
          }else{
            this.Toast({
              mask: true,
              message: res.data.msg
            });
          }
        },err =>{
          this.requestOnce = true;
          this.tableLoading = false;
          this.Toast.clear();
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          });
          console.log(err)
        });
      }
    },
    touchin(index) {
      var _this = this;
      clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
      this.Loop = setTimeout(function() {
        _this.deleteImgDialog(index);
      }.bind(this), 500);
    },
    cleartime(id,course_id) {
      // 这个方法主要是用来将每次手指移出之后将计时器清零
      clearInterval(this.Loop);
    },
    openFullscreenDialog (index) {
      this.bigImg = this.src[index];
      this.openFullscreen = true;
    },
    closeFullscreenDialog () {
      this.openFullscreen = false;
    },
    handleSortChange ({name, order}) {
      this.list = this.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name]);
    },
    changeCheckBox(v){
      console.log(this.form.checkbox)
    },
    deleteImgDialog (index) {
      // 删除图片 打开
      this.deleteIndex = index;
      this.openAlert = true;
    },
    closeAlertDialogGoRecord(state){
      if(state === 'y'){
        this.submits();
      }
      this.openAlertDj = false;
    },
    closeAlertDialog (state) {
      // 删除图片 关闭
      if(state === 'y'){
          this.src.splice(this.deleteIndex, 1);
          this.files.splice(this.deleteIndex, 1);
      }
      this.openAlert = false;
    },

    submits(){
      this.Toast.loading({message: '提交中'});
      let data = Object.assign({},this.$store.state.user,{
        content: {
          form: this.form,
          details: this.list,
          code: this.type,
          files: this.files
        }
      });
      /* 发送post请求 */
      if(this.requestOnce){
        this.common.reqData(api.app('CheckRecordSaveCheckRecord'), data, res=>{
          this.requestOnce = true;
          this.Toast.clear();
          console.log("返回数据：", res.data)
          if(res.data.status == 100){
            this.Toast({
              duration: 2000,
              mask: true,
              message: '提交成功'
            });
            this.isSubmited = true;
            this.common.printVal({
              code: this.form.vin,
              number: 2
            }, ()=>{
            });
          }else{
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            });
          }
        },err =>{
          this.requestOnce = true;
          this.Toast.clear();
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          });
          console.log(err)
        });
      }
    },
    
    paizhao(){
      let _this = this;
      if(window.plus){
        var cmr = plus.camera.getCamera();
        var res = cmr.supportedImageResolutions[0];
        var fmt = cmr.supportedImageFormats[0];
        console.log("Resolution: "+res+", Format: "+fmt);
        cmr.captureImage( function( path ){
            plus.io.resolveLocalFileSystemURL( path, function ( entry ) {
                // 转化本地绝对路径
                var url = plus.io.convertLocalFileSystemURL(path);
                _this.src.push("file://"+url);
                // 获取图片对象
                entry.file( function(file){
                    var fileReader = new plus.io.FileReader();
                    fileReader.onloadend = function(evt) {
                        console.log(evt.target.result);
                        _this.files.push(evt.target.result);
                    }
                    fileReader.readAsDataURL(file);
                });
            });
        },
        function( error ) {
            console.log( "拍照已经取消: " + error.message );
        },
        {resolution:res,format:fmt}
        );
      }
    },
    closeing (val) {
      val ? this.isScanning = false : null;
    },
    childByValue (val) {
      if(val){
        if(val.split('&')[1] == 'vin'){
          this.form.vin = val.split('&')[0];
          this.getData();
        }
      }
    },
    scan (txt) {
      this.scanMark = txt;
      this.isScanning = true;
    },
    closeFullscreenDialog(){
      this.openFullscreen = false;
      this.closeScan();
    }
  },
  mounted () {
    
  },
  watch: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.auto-width{
  width: 95%;
  margin: 10px auto;align-items: baseline!important;
}
.input{
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}
#mytable .mu-input{
  width: 100%;
  margin: 0;
}
.vin-btns{
  display: flex;
  width: 85%;
  margin-top: 20px;
  padding-bottom: 20px;
  justify-content: space-between;
}
.vin-btns button{
  margin: 0 0;
}
.photos{
    border: 1px solid #ccc;
    width: 90%;
    margin: 20px auto 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.paper, .state, .msg{
  width: 85%;
  margin: 2em auto 0;
  padding: 1.5em 1rem;
}
i.iconfont.icon-icon25201{
    display: block;
    font-size: 50px;
    margin: 10px;
}
.text-right{
  text-align: right;
}
.list-content{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/vin.vue